import { useState, useEffect, useCallback } from "react";

import isFilled from "../utilities/isFilled.js";

/* 
    Hook que realiza una llamada HTTP contra una API REST.

    Entrada (no es necesario pasar todos los parametros):
        - url = props[0]
        - headers = props[1]
        - method = props[2]
        - body = props[3]
        - render = props[4]

    Salida:
        - serviceResponse{data, message, success}
        - error
        - loading
*/
const useFetch  = (...props) => {
    const[serviceResponse, setServiceResponse] = useState({data: "", message: "", success: ""}) ;
    const[error, setError] = useState("") ;
    const[loading, setLoading] = useState(true) ;

    const handleFetch = useCallback(
        async () => {
            if((props[2] == 'POST' || props[2] == 'PUT') && !(isFilled(props[3]))){
                return { serviceResponse, error, loading } ;
            }
            try{
                await fetch(props[0], {
                    method: props[2],
                    headers: props[1],
                    body: (isFilled(props[3]) && (props[2] == 'POST' || props[2] == 'PUT')) ? props[3] : null
                })
                .then(response => response.json())
                .then((data) => {
                    setServiceResponse({data: data.data, message: data.message, success: data.success})
                    setError(data.error)
                    setLoading(false)
                }, []);
            } 
            catch (error){
                setServiceResponse({data: "", message: error.message, success: false})
                setError(error.message)
                setLoading(false)
            }
        }
    )

    useEffect(() => {
        if (!isFilled(serviceResponse.data) || serviceResponse.message == "API014" || serviceResponse.success) handleFetch()
    }, [props[0], props[3], props[4]]);

    return { serviceResponse, error, loading } ;
}

export default useFetch ;